<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
export default {
    name: "App",
};
</script>
<style>
* {
    margin: 0;
    padding: 0;
    list-style-type: none;
    scrollbar-color: #00000070 #00000020;
    scrollbar-width: thin;
    outline:none;
}
a,img {
    border: 0;
    outline: none;
    text-decoration: none;
}
html,body {
    background-color: #F2F4F7;
    font: 12px/160% Arial, Helvetica, sans-serif, "SimSun", "FontAwesome" !important;
    font-family: "microsoft yahei";
    color: #333;
    z-index: 1;
    height: 100%;
}
h1,h2,h3,h4,h5,h6,button,input,select,textarea {
    font-size: 100%
}
.clear {
    clear: both;
}
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}
::-webkit-scrollbar-track-piece {
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -o-border-radius: 6px;
    -ms-border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
}
::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(125, 125, 125, 0.7);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -o-border-radius: 6px;
    -ms-border-radius: 6px;
    border-radius: 6px;
}
::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: rgba(125, 125, 125, 0.7);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -o-border-radius: 6px;
    -ms-border-radius: 6px;
    border-radius: 6px;
}
</style>
